module.exports = __webpack_public_path__ + "media/advertise_with_us/who-we-are-bg-6ba5d98e.jpg";